import { useEffect, useRef, type CSSProperties, type ReactNode } from 'react';

/**
 * Editorial reveal. Text-only blocks sequence their direct children
 * (eyebrow → heading → paragraph → CTA). Blocks that contain photography keep
 * the original whole-block fade so approved image reveals look unchanged.
 */
export default function Reveal({ children, className = '', delay = 0 }: { children: ReactNode; className?: string; delay?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (!el.querySelector('img, video')) el.classList.add('reveal-seq');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            el.classList.add('is-visible');
            io.disconnect();
          }
        });
      },
      { threshold: 0.12 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={`reveal ${className}`}
      style={{ transitionDelay: `${delay}ms`, '--reveal-d': `${delay}ms` } as CSSProperties}
    >
      {children}
    </div>
  );
}